import {
    useParams
} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Event from "../../components/Events/EventPage/Event";
import NotFoundPage from "../Errors/NotFound";

import '../../assets/styles/events/conferencePage/conferencePage.scss';
import useEventData from "../../components/Events/hooks/useEventData";
import usePageMeta from "../../services/page-meta";

export default function EventPage() {
    const { t } = useTranslation();
    const { id } = useParams();
    const [eventData, dispatch] = useEventData(id);
    const pageTitle = eventData?.event?.name || t('conferences.title');

    usePageMeta({
        title: pageTitle,
        description: t('app.description'),
        keywords: t('app.keywords'),
    });

    if (!eventData) {
        return null;
    }

    if (eventData.state === 'not_found' || !eventData.event) {
        return <NotFoundPage />;
    }

    return <Event
        event={eventData.event}
        userData={eventData.userData}
        childEvents={eventData.childEvents}
        eventDataUpdate={dispatch}
    /> ;
}
